module.exports = __webpack_public_path__ + "img/aroma-device.73475460.png";